import React from "react";
import "./styles/BusinessPageSkeleton.css";

/**
 * Page-shaped placeholder for /business/:id. Shown while the route chunk
 * downloads (App.tsx Suspense fallback) AND while the business data loads
 * (BusinessListings), so a reload goes skeleton -> real page in one step,
 * with no spinner or "not found"/locked screen flashing in between.
 * Deliberately tiny and dependency-free: it ships in the main bundle.
 */
const BusinessPageSkeleton: React.FC = () => (
  <div className="biz-skel" aria-busy="true" aria-label="Loading business">
    <div className="biz-skel__banner biz-skel__shimmer" />
    <div className="biz-skel__head">
      <div className="biz-skel__logo biz-skel__shimmer" />
      <div className="biz-skel__lines">
        <div className="biz-skel__line biz-skel__line--title biz-skel__shimmer" />
        <div className="biz-skel__line biz-skel__line--sub biz-skel__shimmer" />
      </div>
    </div>
    <div className="biz-skel__tabs">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="biz-skel__tab biz-skel__shimmer" />
      ))}
    </div>
    <div className="biz-skel__grid">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="biz-skel__card">
          <div className="biz-skel__card-img biz-skel__shimmer" />
          <div className="biz-skel__line biz-skel__line--card biz-skel__shimmer" />
        </div>
      ))}
    </div>
  </div>
);

export default BusinessPageSkeleton;
